import { allArticles } from "../data/faqs/index";
import { createSearchIndex } from "../lib/searchEngine";

// Built once per page load: ~90 ms for 165 articles, then a few ms per query.
const index = createSearchIndex(allArticles());

/**
 * Help articles matching `keyword`, best first, as [{ article, snippet }].
 *
 * `categorySlug` narrows to one category (the category page's own box).
 * `options.limit` caps the list; `options.prefix` treats the last word as still
 * being typed, for the suggestions under the search boxes.
 */
export function searchArticles(keyword, categorySlug, options = {}) {
  return index.search(keyword || "", { ...options, category: categorySlug || null });
}

export default searchArticles;
